export default __webpack_public_path__ + "static/media/external-link.a89f4da6.svg";